// This file was automatically generated from app.settings.staffDelegates.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.settings.staffDelegates');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.staffDelegates.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h1 class="el8PageTitle">Provider Managed Delegates</h1><!-- RX SECTION --><h3 class="el8SectionHeader">Sign Prescriptions</h3><p class="padb10">Delegates can execute verbal prescription orders on my behalf. These verbal orders include:<p><ul class="padb10 padl20 ebs-list-unstyled"><li class="el8BulletText mv5">Transcribing and sending a new prescription electronically to the pharmacy.</li><li class="el8BulletText mv5">Transcribing and sending approval or denial electronically of a prescription refill request.</li><li class="el8BulletText mv5">Documenting a medication as discontinued.</li>', (el8Globals.FEATURES.NewSurescripts) ? '<li class="el8BulletText mv5">Transcribing my order to electronically request a prescription be cancelled to the pharmacy on my behalf.</li><li class="el8BulletText mv5">Transcribing my verbal approval or denial of a prescription change request received from a pharmacy and sending that approval or denial electronically to the pharmacy on my behalf.</li>' : '', '</ul><p class="padb10">I understand that I take full responsibility for the prescription orders that are written on my behalf by the individuals I have authorized to act as my Delegates.</p>', (el8Globals.FEATURES.MDToolboxEPCS) ? '<p class="padb10">Please note the following exception: Staff Delegates will not be allowed to ePrescribe controlled substance medications on your behalf due to DEA regulations.</p>' : '');
  el8.template.app.settings.staffDelegates.delegatedStaffWidget({title: 'Authorized Rx Delegates', permissionType: 'rxs'}, output);
  output.append('<!-- ORDER SECTION --><h3 class="el8SectionHeader mt30">Sign Orders</h3><p class="padb10">Delegates can execute verbal lab, imaging, cardiac, sleep, and pulmonary orders on my behalf.<p>');
  el8.template.app.settings.staffDelegates.delegatedStaffWidget({title: 'Authorized Order Delegates', permissionType: 'orders'}, output);
  output.append('<!-- BILL SECTION --><h3 class="el8SectionHeader mt30">Edit Signed Bills</h3><p class="padb10">Delegates can edit bills after I have signed the associated visit notes.<p>');
  el8.template.app.settings.staffDelegates.delegatedStaffWidget({title: 'Authorized Billing Delegates', permissionType: 'bills'}, output);
  output.append('<!-- REFERRAL SECTION --><h3 class="el8SectionHeader mt30">Edit and Send Referrals</h3>');
  if (el8Globals.FEATURES.StaffGroupDelegates) {
    output.append('<p class="padb10">Delegates can execute verbal editing and sending of referrals on my behalf.<p>');
    el8.template.app.settings.staffDelegates.delegatedStaffWidget({title: 'Authorized Referral Delegates', permissionType: 'referrals'}, output);
  } else {
    output.append('<form><div class="el8FieldSection ebs-clearfix"><div class="confirm-msg ebs-col-xs-2 ebs-col-xs-push-10 el8Bold padt10"></div><div class="ebs-col-xs-10 ebs-col-xs-pull-2 padl30"><div><label class="ebs-radio"><input type="radio" name="allowStaffToSendReferral" value="on"/>Allow staff in my practice to execute a verbal order to sign and send referrals on my behalf. In the event of an emergency situation when I am not available, I authorize the staff in my practice to sign and send referrals on my behalf.</label></div><div class="mt20 padb5"><label class="ebs-radio"><input type="radio" name="allowStaffToSendReferral" value="off"/>Allow staff to prepare referrals for me to sign, but do not allow staff to sign and send referrals on my behalf.</label></div></div></div></form>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.staffDelegates.delegatedStaffWidget = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="ebs-row"><div class="ebs-col-sm-6"><div class="el8ActiveUserHeading">', soy.$$escapeHtml(opt_data.title), '</div><div class="', soy.$$escapeHtml(opt_data.permissionType), '-delegated-group-list el8Loading">');
  el8.template.app.settings.staffDelegates.delegatedStaffGroupList(opt_data, output);
  output.append('</div><div class="', soy.$$escapeHtml(opt_data.permissionType), '-delegated-list el8Loading">');
  el8.template.app.settings.staffDelegates.delegatedStaffList(opt_data, output);
  output.append('</div><div class="el8UserListItem"><form><div class="el8FieldSection mt5"><input type="text" class="el8TextareaWrap ebs-form-control" name="newDelegate', (soy.$$escapeHtml(opt_data.permissionType)? soy.$$escapeHtml(opt_data.permissionType).capitalize() : ''), '" /></div></form></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.staffDelegates.delegatedStaffList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.delegatedStaff) {
    var staffList7455 = opt_data.delegatedStaff;
    var staffListLen7455 = staffList7455.length;
    if (staffListLen7455 > 0) {
      for (var staffIndex7455 = 0; staffIndex7455 < staffListLen7455; staffIndex7455++) {
        var staffData7455 = staffList7455[staffIndex7455];
        output.append('<div class="el8UserListItem"><p class="el8LargerText">', soy.$$escapeHtml(staffData7455.name), '<a class="remove-delegate-trigger el8StandardFontSize ml10" data-id="', soy.$$escapeHtml(staffData7455.id), '" data-permission="', soy.$$escapeHtml(opt_data.permissionType), '">Remove</a></p></div>');
      }
    } else {
      output.append('<div class="el8UserListItem"><p class="el8LargerText el8GreyText"><i>You have not authorized any staff delegates.</i></p></div>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.staffDelegates.delegatedStaffGroupList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.delegatedStaffGroups) {
    var groupList7469 = opt_data.delegatedStaffGroups;
    var groupListLen7469 = groupList7469.length;
    for (var groupIndex7469 = 0; groupIndex7469 < groupListLen7469; groupIndex7469++) {
      var groupData7469 = groupList7469[groupIndex7469];
      output.append('<div class="el8UserListItem">', soy.$$escapeHtml(groupData7469.name), ' <small>(admin added)</small></div>');
    }
  }
  if (!opt_sb) return output.toString();
};
